/* AUTO-GENERATED from /schemas/*.schema.json — DO NOT EDIT.
   Regenerate with: node tooling/contracts/generate.mjs */

export const CATERING_FACT_OPTIONS = {
  "catering.types": {
    "multiple": true,
    "values": [
      "fingerfood",
      "menu",
      "buffet",
      "bbq",
      "trade_fair",
      "live_cooking"
    ]
  },
  "catering.purpose": {
    "multiple": false,
    "values": [
      "snack",
      "satt"
    ]
  },
  "catering.service_form": {
    "multiple": false,
    "values": [
      "self-service",
      "flying",
      "plated",
      "assisted_buffet",
      "cocktail_bar",
      "mixed",
      "other"
    ]
  },
  "catering.food_direction": {
    "multiple": true,
    "values": [
      "fingerfood",
      "sandwiches",
      "breakfast",
      "hot_food",
      "cold_food",
      "savory",
      "sweet",
      "italian",
      "mediterranean",
      "north_german",
      "international",
      "crossover",
      "oriental",
      "american",
      "classic",
      "modern",
      "winter",
      "fine_dining",
      "other"
    ]
  },
  "catering.culinary_style": {
    "multiple": true,
    "values": [
      "italian",
      "mediterranean",
      "north_german",
      "international",
      "crossover",
      "oriental",
      "american",
      "classic",
      "modern",
      "winter",
      "fine_dining",
      "other"
    ]
  },
  "logistics.seating_type": {
    "multiple": false,
    "values": [
      "standing_tables",
      "seated_tables",
      "mixed",
      "theatre",
      "rows",
      "other"
    ]
  },
  "logistics.seating_availability": {
    "multiple": false,
    "values": [
      "no_seats",
      "some_seats",
      "all_seats"
    ]
  }
} as const;
